// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"Skeletons-primaryButton-3OMDBC","skeletons":"Skeletons-skeletons-1lTeBW","container":"Skeletons-container-2zeYah","skeleton":"Skeletons-skeleton-vpEE6b"};